import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DoneEventsEmptyState from './DoneEventsEmptyState';
import DoneEventsContent from './DoneEventsContent';
import PerformanceCard from '../PerformanceCard';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceDoneEventsCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import { DONE_EVENTS } from '../../constants';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function DoneEvents() {
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();
  const { doneEvents } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const {
    loading,
    hasFetched,
    value,
    variation,
    percentage_status,
    icon,
    error,
  } = doneEvents;
  const [selectedOption, setSelectedOption] = useState(DONE_EVENTS.EVENT);
  const showEmptyState = error || (hasFetched && value === 0);

  const allowedOptions = [
    { id: DONE_EVENTS.EVENT, text: Trans(translations, 'Event') },
    {
      id: DONE_EVENTS.CLOSING_REASON,
      text: Trans(translations, 'ClosingReason'),
    },
    {
      id: DONE_EVENTS.QUALIFICATION,
      text: Trans(translations, 'Qualification'),
    },
  ];

  const handleClickRadio = (item) => {
    setSelectedOption(item.id);
    track.eventsMade(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceDoneEventsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'doneEvents',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard ref={ref} loading={loading || isStale} id="done-events">
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'EventsMade')}
      </PerformanceCard.Header>
      {showEmptyState ? (
        <DoneEventsEmptyState />
      ) : (
        <>
          <PerformanceCard.Summary
            value={value}
            percentageStatus={percentage_status}
            tendency={variation}
            icon={icon}
          >
            <RadioButtonsGroup
              allowedOptions={allowedOptions}
              selectedOption={selectedOption}
              onClickRadio={handleClickRadio}
            />
          </PerformanceCard.Summary>
          <DoneEventsContent selectedOption={selectedOption} />
        </>
      )}
    </PerformanceCard>
  );
}
